module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row bg-white max-height-vertical max-height-auto box-overflow"
  }, [_c('full-span-slide', {
    attrs: {
      "active": _vm.active
    }
  }, [_c('p', {
    staticClass: "large",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "utility bump-down-12-mobile"
  }, [_c('strong', [_vm._v("Click")]), _vm._v(" the correct answer before proceeding to the "), _c('strong', [_vm._v("'Next'")]), _vm._v(" button.")]), _vm._v(" "), _c('div', {
    staticClass: "row span-16-lg"
  }, _vm._l((_vm.content.options), function(option) {
    return _c('radio-span', {
      key: option.index,
      attrs: {
        "strong": option.strong,
        "correct": option.correct,
        "caption": option.caption,
        "title": option.title
      }
    })
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95897aee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/templates/pages/checkbox_page.vue
// module id = 649
// module chunks = 1